__turbopack_context__.v({
  "backdrop": "PrefijoWhatsappModalSelector-module__RxyiPq__backdrop",
  "clearSearchBtn": "PrefijoWhatsappModalSelector-module__RxyiPq__clearSearchBtn",
  "dialCodePill": "PrefijoWhatsappModalSelector-module__RxyiPq__dialCodePill",
  "fadeIn": "PrefijoWhatsappModalSelector-module__RxyiPq__fadeIn",
  "flagBadge": "PrefijoWhatsappModalSelector-module__RxyiPq__flagBadge",
  "iconBadge": "PrefijoWhatsappModalSelector-module__RxyiPq__iconBadge",
  "modalCard": "PrefijoWhatsappModalSelector-module__RxyiPq__modalCard",
  "prefixButton": "PrefijoWhatsappModalSelector-module__RxyiPq__prefixButton",
  "prefixButtonSelected": "PrefijoWhatsappModalSelector-module__RxyiPq__prefixButtonSelected",
  "prefixGrid": "PrefijoWhatsappModalSelector-module__RxyiPq__prefixGrid",
  "prefixListScroll": "PrefijoWhatsappModalSelector-module__RxyiPq__prefixListScroll",
  "searchContainer": "PrefijoWhatsappModalSelector-module__RxyiPq__searchContainer",
  "searchIconWrapper": "PrefijoWhatsappModalSelector-module__RxyiPq__searchIconWrapper",
  "searchInput": "PrefijoWhatsappModalSelector-module__RxyiPq__searchInput",
  "zoomIn": "PrefijoWhatsappModalSelector-module__RxyiPq__zoomIn",
});
